import React from 'react';
import { motion } from 'framer-motion';

import Button from '../../../components/ui/Button';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange, viewMode, onViewModeChange }) => {
  const categoryIcons = {
    'All': 'Grid3x3',
    'Web Development': 'Monitor',
    'Creative Coding': 'Zap',
    'Brand Campaigns': 'Megaphone',
    'Mobile Apps': 'Smartphone',
    'UI/UX Design': 'Palette'
  };

  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 mb-8">
      {/* Category Filters */}
      <div className="flex flex-wrap gap-2">
        {categories?.map((category) => (
          <motion.div
            key={category}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              variant={activeCategory === category ? "default" : "outline"}
              size="sm"
              onClick={() => onCategoryChange(category)}
              iconName={categoryIcons?.[category] || 'Folder'}
              iconPosition="left"
              iconSize={16}
              className={`${
                activeCategory === category
                  ? 'bg-accent text-background border-accent cosmic-glow' :'border-border/30 text-muted-foreground hover:text-foreground hover:border-accent/50'
              } transition-all duration-300`}
            >
              {category}
            </Button>
          </motion.div>
        ))}
      </div>
      {/* View Mode Toggle & Controls */}
      <div className="flex items-center space-x-4">
        {/* View Mode Toggle */}
        <div className="flex items-center space-x-2">
          <span className="text-sm text-muted-foreground font-body">View:</span>
          <div className="flex items-center glass-panel rounded-lg p-1">
            <Button
              variant={viewMode === '3d' ? "default" : "ghost"}
              size="xs"
              onClick={() => onViewModeChange('3d')}
              iconName="Box"
              iconSize={14}
              className={`${
                viewMode === '3d' ?'bg-accent text-background' :'text-muted-foreground hover:text-foreground'
              } transition-all duration-200`}
            >
              3D
            </Button>
            <Button
              variant={viewMode === 'grid' ? "default" : "ghost"}
              size="xs"
              onClick={() => onViewModeChange('grid')}
              iconName="Grid3x3"
              iconSize={14}
              className={`${
                viewMode === 'grid' ?'bg-accent text-background' :'text-muted-foreground hover:text-foreground'
              } transition-all duration-200`}
            >
              Grid
            </Button>
          </div>
        </div>

        {/* Additional Controls */}
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="xs"
            iconName="Search"
            iconSize={16}
            className="text-muted-foreground hover:text-foreground"
            title="Search Projects"
          />
          <Button
            variant="ghost"
            size="xs"
            iconName="Filter"
            iconSize={16}
            className="text-muted-foreground hover:text-foreground"
            title="Advanced Filters"
          />
          <Button
            variant="ghost"
            size="xs"
            iconName="SortAsc"
            iconSize={16}
            className="text-muted-foreground hover:text-foreground"
            title="Sort Projects"
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;